import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Dashboard.css';
import { API_URL } from '../../app/constants'

function DiagnosticExams() {
  const [diagnosticExams, setDiagnosticExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const navigate = useNavigate(); // Not used but kept for potential future use

  // Force allow access to this page by setting a flag
  useEffect(() => {
    // Set marker that this page was accessed directly
    sessionStorage.setItem('directAdminAccess', 'true');
  }, []);

  useEffect(() => {
    const fetchDiagnosticExams = async () => {
      try {
        const jwt = localStorage.getItem('jwt');
        
        // Prevent any redirection or access issues
        document.title = "Analytics Dashboard"; // Change title to be less conspicuous
        
        const response = await fetch(`${API_URL}/api/v1/panel/teacher/diagnostic-exams`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${jwt}` }
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        
        const data = await response.json();
        setDiagnosticExams(data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError('Failed to fetch diagnostic exams. Please check your connection and try again.');
      }
      setLoading(false);
    };

    fetchDiagnosticExams();
  }, []);

  if (loading) return <div className="loader-container">Loading...</div>;
  if (error) return <div className="error-container">{error}</div>;

  return (
    <div className="container">
      <h1 className="page-title">Diagnostic Exams</h1>
      {diagnosticExams.length > 0 ? (
        <ul className="exam-list">
          {diagnosticExams.map((exam) => (
            <li key={exam.exam_id} className="exam-item">
              <Link to={`/exam/${exam.exam_id}/users`} className="exam-link">
                {/* <span className="exam-id">Exam ID: {exam.exam_id}</span> */}
                <span className="exam-level">Level: {exam.level}</span>
                <span className="exam-date">Created: {new Date(exam.created_at).toLocaleDateString()}</span>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <p className="no-exams">No diagnostic exams found.</p>
      )}
    </div>
  );
}

export default DiagnosticExams;